import {getBaseURL, getPostRequestOptions} from '../utils';

export type AIRequestParams = {
    content: string;
    enhancementType: string;
    enhancementOption: string;
    language: string;
};

// 'This is to inform you that a price increase has been detected. Please review the updated pricing details and take necessary actions.'

const mockedResponse = {
    enhancedContent:
        '<p>We are writing to formally notify you of a recent pricing adjustment. Kindly review the updated pricing information and proceed with the appropriate follow-up actions.</p>'
};

export type ErrorResponse = {
    code?: number;
    message?: string;
};

type Response = {
    enhancedContent?: string;
};

export const getEnhancedMail = async (
    params: AIRequestParams
): Promise<Response & ErrorResponse> => {
    const returnTestResponse =
        new URLSearchParams(window.location.search).get('_ai_search_test') === '1';

    if (returnTestResponse) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(mockedResponse);
            }, 1000);
        });
    }

    return fetch(`${getBaseURL()}/llm-services/enhanceMail`, getPostRequestOptions(params))
        .then(res => {
            return res.json();
        })
        .then(data => data);
};
